import React from "react";
import { motion } from "framer-motion";
import { FaClipboardCheck, FaCodeBranch, FaUserShield, FaClock } from "react-icons/fa";

const items = [
  {
    icon: FaClipboardCheck,
    title: "Çfarë nënkupton 'punë e kryer'",
    text: "Çdo fazë mbyllet me lista kontrolli, teste dhe dokumentim të qartë — jo vetëm kodin e dorëzuar.",
  },
  {
    icon: FaCodeBranch,
    title: "Kod i organizuar",
    text: "Histori Git e pastër, kod i strukturuar dhe komente të qarta — të kuptueshme edhe pas muajsh nga çdo zhvillues.",
  },
  {
    icon: FaUserShield,
    title: "Siguria e të dhënave",
    text: "Aksese të kufizuara, mjedise të ndara dhe NDA e disponueshme për projekte konfidenciale.",
  },
  {
    icon: FaClock,
    title: "Komunikim i rregullt",
    text: "Përditësime javore me shkrim dhe komunikim i drejtpërdrejtë — gjithmonë e dini ku jemi dhe çfarë vjen më pas.",
  },
];

function Stats() {
  return (
    <section
      className="commitments section-pad"
      id="commitments"
      aria-labelledby="commitments-heading"
    >
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Garanci</span>
          <h2 id="commitments-heading">Si e bëjmë punën siç duhet</h2>
          <p>
            Këto nuk janë thjesht fjalë — janë mënyra si punojmë me çdo klient, në çdo projekt.
          </p>
        </div>

        <div className="commitments-grid">
          {items.map(({ icon: Icon, title, text }, i) => (
            <motion.article
              key={title}
              className="commitment-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              viewport={{ once: true, margin: "-40px" }}
            >
              <span className="commitment-icon" aria-hidden="true">
                <Icon />
              </span>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
